import withErrorWrapper from '../../../hoc/WithErrorWrapper';
import view from './IncomeSourcesCardView';

export default withErrorWrapper(view);
